import React, { useContext } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "../common/context/AdvancedOptions";
const StyledAdditionalFields = styled(AdditionalFields)`
  margin: 0 0 35px;
`;
const FormAdvancedOptions = ({ onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { overrideSource, onePasswordThrottleEnabled, onePasswordStoreFullMessage } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(
    StyledAdditionalFields,
    {
      title: t("common.fields.advanced_options"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "onePasswordThrottleEnabled",
        type: "checkbox",
        value: "enable-throttling",
        defaultChecked: onePasswordThrottleEnabled == null ? void 0 : onePasswordThrottleEnabled.value,
        onChange,
        label: t("common.fields.enable_throttling"),
        help: t("onepassword.advanced_options.enable_throttling_help")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "onePasswordStoreFullMessage",
        type: "checkbox",
        value: "enable-storeFullMessage",
        defaultChecked: onePasswordStoreFullMessage == null ? void 0 : onePasswordStoreFullMessage.value,
        onChange,
        label: t("common.fields.store_full_message"),
        help: t("onepassword.advanced_options.store_full_message_help")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "overrideSource",
        type: "text",
        value: overrideSource == null ? void 0 : overrideSource.value,
        onChange,
        label: t("onepassword.advanced_options.override_source"),
        help: t("onepassword.advanced_options.override_source_help")
      }
    )
  );
};
export default FormAdvancedOptions;
